import React from "react"
import { usePersonnelDetailsContext } from "../PersonnelDetails"
import DocumentCategory from "../documents/_DocumentCategory"
import PersonnelDeclarations from "../documents/_PersonnelDeclarations"
import MaladieSection from "./_MaladieSection"
import DdcSection from "./_DdcSection"

// Onglet "Activité" de la fiche staff : déclarations mensuelles, arrêts maladie et demandes de congés
// du collaborateur, regroupés en sections repliables. Arrêts maladie en consultation seule ;
// les congés proposent Valider / Rejeter au responsable hiérarchique.
const Activite = () => {
     const context = usePersonnelDetailsContext()
     const personnelId = context.detailsQuery.data?.personnel?.id as number
     // Le connecté est-il responsable (ou au-dessus) du collaborateur ? -> boutons Valider / Rejeter des congés.
     const canValiderConges = context.detailsQuery.data?.connectedUserCanValiderDeclarations === true

     return (
          <div className={"d-flex flex-column gap-6"}>
               <DocumentCategory title={"Déclarations"} subtitle={"Déclarations d'activité mensuelles"} icon={"fa-file-signature"} color={"primary"} maxHeightPx={760}>
                    <PersonnelDeclarations />
               </DocumentCategory>

               <DocumentCategory title={"Arrêts maladie"} subtitle={"Arrêts de travail du collaborateur"} icon={"fa-file-medical"} color={"danger"} maxHeightPx={760}>
                    <MaladieSection personnelId={personnelId} />
               </DocumentCategory>

               <DocumentCategory title={"Demandes de congés"} subtitle={"Congés du collaborateur"} icon={"fa-umbrella-beach"} color={"warning"} maxHeightPx={760}>
                    <DdcSection personnelId={personnelId} canValider={canValiderConges} />
               </DocumentCategory>
          </div>
     )
}

export default Activite
